import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export interface UpdateAdminUserBasicInfo {
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  preferred_name?: string;
  gender?: string;
  gender_identity?: string;
  date_of_birth?: string;
  pronouns?: string;
  languages?: number[];
}

export interface UpdateAdminUserAddress {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip_code: string;
}

export interface UpdateAdminUserPayload {
  basic_info?: UpdateAdminUserBasicInfo;
  address?: UpdateAdminUserAddress;
  phone_number?: string;
  client_ids?: number[];
  /** Rides with client_ids, but can be sent alone — omitting client_ids grandfathers the user's existing tag set. */
  client_division_ids?: number[];
  guardian_relationship?: string;
  email?: string;
  /** Max 40 characters, enforced by the backend. */
  external_id?: string;
}

export const updateAdminUser = async (user_id: number, payload: UpdateAdminUserPayload): Promise<UserProfile> => {
  const { data } = await client.patch<UserProfile>(`/admin/users/${user_id}`, payload);
  return data;
};
